module.exports = __webpack_public_path__ + "static/img/stamp_00.ed65afe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_00.jpg
// module id = gbzI
// module chunks = 7